// extracted by mini-css-extract-plugin
export default {"root":"ProjectTable_root__DJI6Y","headerRow":"ProjectTable_headerRow__6g4VP"};